import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { environment } from '../../../../environments/environment';

/** Recolhe a rota de perfis de acesso quando a funcionalidade está desligada no ambiente. */
export const accessProfilesFeatureGuard: CanActivateFn = () =>
  environment.features.accessProfiles || inject(Router).createUrlTree(['/acesso-negado']);
